<template>
	<el-container class="home">
		<el-header height="80px" class="elheader">
			<div class="logo">
				<font size="5">{{$config.sysName}}-后台数据管理</font>
			</div>
			<div class="header-right">
				<div class="header-user-con">
					<div class="btn-fullscreen" @click="fullScreen"><i class="el-tooltip el-icon-rank"></i></div>
					<div class="user-name el-dropdown">
						<el-dropdown trigger="click" @command="handleCommand">
							<span class="el-dropdown-link">
								{{userInfo.name}}
								<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<!-- <el-dropdown-item command="profile">个人中心</el-dropdown-item> -->
								<el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</div>
		</el-header>
		<el-container>
			<el-aside width="250px">
				<el-row>
					<el-col>
						<el-menu default-active="/sys/index" unique-opened class="el-menu-vertical">
							<div v-for="(item,index) in menu">
								<el-submenu :index="'submenu_'+index" v-if="item.list">
									<template slot="title">
										<i :class="item.mdi"></i>
										<span>{{item.name}}</span>
									</template>
									<el-menu-item-group>
										<el-menu-item :index="item2.href" v-for="(item2,index2) in item.list"
											@click="menuCommand(item2)" style="padding-left: 50px;">{{item2.name}}
										</el-menu-item>
									</el-menu-item-group>
								</el-submenu>
								<el-menu-item :index="item.href" v-else @click="menuCommand(item)"> <i
										:class="item.mdi"></i><span slot="title">{{item.name}}</span></el-menu-item>
							</div>
						</el-menu>
					</el-col>
				</el-row>
			</el-aside>
			<el-main class="elmain">
				<router-view></router-view>
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
	import {
		mapMutations,
		mapGetters
	} from 'vuex'

	//对应不同版本软件-设置后台功能菜单 
	// 完整版本-课程平台
	import menu from './menu_js/menu.js'
	// 赛训视听交互式学习系统
	// import menu from './menu_js/menu_jhskj.js'
	// vr版本-1+x后台
	// import menu from './menu_js/menu_vr.js'

	// 其他
	// import menu from './menu_js/menu_huozai.js'
	// import menu from './menu_js/menu_tiku.js'

	//电子书
	// import menu from './menu_js/ebook.js'



	export default {
		data() {
			return {
				isFullScreen: false, //是否全屏
				starInterval: '',
				menu: [],
				userInfo: {}
			}
		},
		created() {

			//验证是否有存储登录信息
			if (this.getUserInfo == null) {
				this.exit()
			} else if (JSON.stringify(this.getUserInfo) == "{}") {
				this.exit()
			} else {
				this.userInfo = this.getUserInfo

				// 学生-通过地址直接切换进来的，强制跳转登录界面
				if (this.userInfo.roleID == 5) {
					this.$router.push('/syslogin')
				} else {
					//加载权限列表
					this.loadUserMenu()
				}
			}
		},
		computed: {
			...mapGetters(['getUserInfo'])
		},
		methods: {
			...mapMutations(['setUserInfo']),
			exit() {
				//未登录 跳转登录页
				this.$router.push({
					path: '/syslogin'
				})
				return false
			},
			handleCommand(e) {
				//退出
				if (e === 'logout') {
					this.$confirm('确定退出?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.logout()
					})
				}
				//个人中心
				if (e === 'profile') {

				}
			},
			logout() {
				this.$http.get('api/Client/LogOff').then(res => {
					this.setUserInfo(null)
					this.$router.push({
						path: '/syslogin'
					})
				})
			},
			menuCommand(e) {
				if (this.$route.path != (e.href)) this.$router.push(e.href)
			},
			loadUserMenu() {
				//根据用户筛选是否有产品权限
				this.$http.get('api/Product/GetProductList').then(res => {
					this.productList = res.data.data.map(item => {
						return item.id
					})
					this.menu = menu.loadMenu(this.getUserInfo.roleID, this.$config, this.productList)
				})
			},
			fullScreen() {
				if (this.isFullScreen) {
					this.$exitFullscreen()
					this.isFullScreen = false
				} else {
					this.$fullScreen()
					this.isFullScreen = true
				}
			}
		}
	}
</script>

<style lang="scss">
	.home {
		.elheader {
			background-color: #000;
			color: #fff;
			font-size: 18px;

			.logo {
				float: left;
				width: 500px;
				line-height: 80px;
			}

			.header-right {
				float: right;
				padding-right: 20px;

				.header-user-con {
					display: -webkit-box;
					display: -ms-flexbox;
					display: flex;
					height: 80px;
					-webkit-box-align: center;
					-ms-flex-align: center;
					align-items: center;

					.btn-fullscreen {
						position: relative;
						width: 30px;
						height: 30px;
						text-align: center;
						border-radius: 15px;
						cursor: pointer;
						-webkit-transform: rotate(45deg);
						transform: rotate(45deg);
						margin-right: 5px;
						font-size: 24px;
					}

					.el-tooltip {
						text-decoration: none;

						.el-icon-bell {
							color: #fff;
						}
					}

					.user-name {
						margin-left: 10px;

						span {
							color: #fff;
							cursor: pointer;
						}
					}
				}
			}
		}

		.el-container {
			.el-aside {
				.el-menu-vertical {
					height: calc(100vh - 95px);

					.mdi {
						margin-right: 5px;
						text-align: left;
						font-size: 20px;
						vertical-align: middle;
					}

					.mdi:before {
						width: 25px;
					}
				}
			}
		}

		.elmain {
			height: calc(100vh - 80px);
			background-color: #f5f6fa;
		}
	}
</style>
